import { PHONE_DISPLAY, PHONE_TEL, EMAIL, whatsappUrl, LOGO_URL } from "../../lib/leads";
import { Phone, Mail } from "lucide-react";
import { WhatsAppIcon } from "./icons";

export const Footer = () => {
  return (
    <footer data-testid="footer" className="relative bg-jodhpur-ink text-white/80 pt-20 pb-10 overflow-hidden">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid gap-12 lg:grid-cols-3 border-b border-white/10 pb-14">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <img src={LOGO_URL} alt="Jodhpur Cabs logo" className="h-16 w-16 rounded-2xl object-contain bg-white p-1" />
              <span className="font-display text-xl font-semibold text-white">Jodhpur Cabs</span>
            </div>
            <p className="text-sm leading-relaxed max-w-xs">
              Your trusted local & outstation taxi partner in the Blue City of Jodhpur, Rajasthan.
            </p>
            <div className="mt-6 flex gap-3">
              <a href={`tel:${PHONE_TEL}`} data-testid="footer-call" className="flex items-center gap-2 rounded-full bg-white/10 hover:bg-white/20 px-4 py-2 text-sm transition-colors">
                <Phone className="h-4 w-4" /> Call
              </a>
              <a href={whatsappUrl("Namaste Jodhpur Cabs!")} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp" className="flex items-center gap-2 rounded-full bg-[#25D366] hover:bg-[#1eb955] px-4 py-2 text-sm text-white transition-colors">
                <WhatsAppIcon className="h-4 w-4" /> WhatsApp
              </a>
            </div>
            <a href={`mailto:${EMAIL}`} data-testid="footer-email" className="mt-4 inline-flex items-center gap-2 text-sm text-white/70 hover:text-jodhpur-accent transition-colors">
              <Mail className="h-4 w-4" /> {EMAIL}
            </a>
          </div>

          <div>
            <h4 className="font-display text-lg text-white mb-4">Popular Routes</h4>
            <ul className="space-y-2 text-sm">
              {["Jodhpur to Jaipur", "Jodhpur to Udaipur", "Jodhpur to Jaisalmer", "Jodhpur to Nakoda Ji"].map((r) => (
                <li key={r}><a href="#routes" className="hover:text-jodhpur-accent transition-colors">{r}</a></li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-display text-lg text-white mb-4">Our Fleet</h4>
            <ul className="space-y-2 text-sm">
              {["Swift Dzire", "Ertiga", "Innova Crysta", "Fortuner", "Urbania"].map((c) => (
                <li key={c}><a href="#fleet" className="hover:text-jodhpur-accent transition-colors">{c}</a></li>
              ))}
            </ul>
          </div>
        </div>

        <div className="pt-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-white/50">
          <p>© {new Date().getFullYear()} Jodhpur Cabs. All rights reserved.</p>
          <p>{PHONE_DISPLAY} · Rukma Nagar, AIIMS Road, Jodhpur 342008</p>
        </div>
      </div>
    </footer>
  );
};
